import { PageContext } from '3-foundation/PageContent/PageContext';
import { useContext } from 'react';
import { UI_BookmarkMenu } from 'ui/components/2-molecules/Navigation/BookmarkMenu/BookmarkMenu';

type Props = Content.BookmarkMenu;

export const BookmarkMenu = ({ content }: Props) => {
	const pageContext = useContext(PageContext);

	const anchorItems: Content.Anchor[] = pageContext.content.pageSections.flatMap((pageSection) => {
		if (pageSection.documentType === 'anchor') {
			return [pageSection]; // top-level anchor
		}

		if (pageSection.documentType === 'contentSection') {
			// nested anchors inside contentSection
			// filter to ensure only anchors are returned
			return pageSection.content.properties.content.filter((module): module is Content.Anchor => module.documentType === 'anchor');
		}

		// other section types, skip
		return [];
	});
	if (!anchorItems.length) return null;
	return (
		<UI_BookmarkMenu
			kicker={content.kicker}
			heading={content.heading}
			text={content.text}
			bookmarkItems={anchorItems.map((item) => {
				const { anchorName } = item?.content?.properties ?? {};
				return {
					title: anchorName,
					id: anchorName?.toLowerCase()?.replace(/\s+/g, '_'),
				};
			})}
		/>
	);
};
